import { render } from "./OrdersPeaksCard.vue?vue&type=template&id=482e8471&scoped=true"
import script from "./OrdersPeaksCard.vue?vue&type=script&lang=js"
export * from "./OrdersPeaksCard.vue?vue&type=script&lang=js"

import "./OrdersPeaksCard.vue?vue&type=style&index=0&id=482e8471&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482e8471"]])

export default __exports__